import type { AgeRange } from "shared/types";

export const LIST_AGE_RANGES = "LIST_AGE_RANGES";

export type AgeRangeDispatchAction = {
  type: typeof LIST_AGE_RANGES;
  payload: { ageRanges: AgeRange[] };
};

export const listAgeRanges = (
  ageRanges: AgeRange[]
): AgeRangeDispatchAction => {
  return {
    type: LIST_AGE_RANGES,
    payload: { ageRanges },
  };
};
